import { render, staticRenderFns } from "./PlaylistTools.vue?vue&type=template&id=127e3c52&"
import script from "./PlaylistTools.vue?vue&type=script&lang=js&"
export * from "./PlaylistTools.vue?vue&type=script&lang=js&"
import style0 from "./PlaylistTools.vue?vue&type=style&index=0&id=127e3c52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports